
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqjgWP7gYc6pwkUlyPB6YtKNkveXUpiVtTbnbHQVVxomoMeta } from "/codebuild/output/src4224255637/src/src/pages/faq.vue?macro=true";
import { default as menuPVC7z5_DcptPL7oaVt_45nn5N05OYoiW69_SrY710xGuoMeta } from "/codebuild/output/src4224255637/src/src/pages/menu.vue?macro=true";
import { default as indexxbc_ceHR420_45A19iUnoBLDl8CHHwWsnnqxsnPsFT_45TYMeta } from "/codebuild/output/src4224255637/src/src/pages/index.vue?macro=true";
import { default as contactAM7FWBCgNvvzUnilgR5KfVmiUSNtONU0UUEahim_454scMeta } from "/codebuild/output/src4224255637/src/src/pages/contact.vue?macro=true";
import { default as tutorialcM_451mf6hnCqeyzTU3dNKdIPP0P0tBgGC3BXyZuefylEMeta } from "/codebuild/output/src4224255637/src/src/pages/tutorial.vue?macro=true";
import { default as agreementMClDUiZttlfcMrGLxGv3LXXgB7GeH8bIhiZqD_45GJxoMMeta } from "/codebuild/output/src4224255637/src/src/pages/agreement.vue?macro=true";
import { default as about_45passvSN4N9BU59DRERjXbUr_452Y2SPhC8HalPtrJmQTLOTKgMeta } from "/codebuild/output/src4224255637/src/src/pages/about-pass.vue?macro=true";
import { default as indexBX6QN7HC_45EVJy6OTapuCbkdDs7aL1IANGLEu_45seGU8YMeta } from "/codebuild/output/src4224255637/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93iT0aSfTIOGFFVpSkeZHI9g8lDstxDbiy9gQ4AyrTZpUMeta } from "/codebuild/output/src4224255637/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceOdSZdt_OwefbQqjURf9ufCF_6ks13oCy_KbWwZjIXD4Meta } from "/codebuild/output/src4224255637/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93r7H1i7U_2554PYtWLSMDE7qtC46_92mtkeQa3V5_miEMeta } from "/codebuild/output/src4224255637/src/src/pages/notice/[id].vue?macro=true";
import { default as indexsFv3HO9pqguYl1Ngx_45BQLRCPds90RMa4bVpE14oTiesMeta } from "/codebuild/output/src4224255637/src/src/pages/coupon/index.vue?macro=true";
import { default as indexURBOuvCsrgzUvD9VRW0O0cIHfediixM1QtKxjg9bWZAMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/index.vue?macro=true";
import { default as index_PSgYaZrsWDMz5CYXFsEmFTr9PfBt_g0VL60rbm9_459sMeta } from "/codebuild/output/src4224255637/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93LpcB73jregtc2JyXsOlNrWAEuaLt0dSwO0UZQvn5mS4Meta } from "/codebuild/output/src4224255637/src/src/pages/parking/[id].vue?macro=true";
import { default as index8PPtmC1j8m7wuu_gRwda32vXpTfLsAFwZ89w8I7vM00Meta } from "/codebuild/output/src4224255637/src/src/pages/history/index.vue?macro=true";
import { default as indexYf697x_45KxgckBTVFTJj3D_45hOB8fjEPOdeuk9B8_45Vo_45EMeta } from "/codebuild/output/src4224255637/src/src/pages/monthly/index.vue?macro=true";
import { default as indexfjiGl1B8ZxKe9Wz4G6lYqukVnlNnMmQjFsn4GCW2K4sMeta } from "/codebuild/output/src4224255637/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexCKmVaDaI3H349pWWUdg8nZxXdsYAxvU8ANLrCljXTAIMeta } from "/codebuild/output/src4224255637/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavibeiLY8u3rfbIOJdGiLdCMGd8Lo6LTrMHOgbjaAHkwcYMeta } from "/codebuild/output/src4224255637/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editpMSzBaEaTNz0bLgolN2_45Kv2CNcKf2SS2sdMYF_csYrsMeta } from "/codebuild/output/src4224255637/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementYaBxdsnySdmcFqzojVkNkY0AJgfa_45BCQ0QL0iOGepUMMeta } from "/codebuild/output/src4224255637/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexEyDO_45TilNN0lRhss75wG9awMShcqGNPjTaUhDMv572AMeta } from "/codebuild/output/src4224255637/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dLqf6Tp7yU6BlBiwoYL9MYXOPO_45_45cF_45OHrwObL3GzRyQMeta } from "/codebuild/output/src4224255637/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmFsa6cY_wTzKM4ZBuIPGsetoRZHJ6Vs3LMQ7Q2guUkQ0Meta } from "/codebuild/output/src4224255637/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexQA9SoH0csux_IbyOyynkIrIemzyJEYV1pkWVsSfShfEMeta } from "/codebuild/output/src4224255637/src/src/pages/card/create/index.vue?macro=true";
import { default as indexesgv6_45TgL61rixwXu5MELVmsy2UbTyygcFVJHR1c25kMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmoY3iXuPg6f1k5rB3PdwY6avJYLyHAhDdexHccyocHzcMeta } from "/codebuild/output/src4224255637/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm50KmfiQAJqlqao7mNwEK9OaZhcbpBG1IG26jYY5AXv0Meta } from "/codebuild/output/src4224255637/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completelmE2PECIGLuxPv3ab0LBoQC4BZBu9qLmVloObZiQTQ0Meta } from "/codebuild/output/src4224255637/src/src/pages/membership/complete.vue?macro=true";
import { default as registerEnUk1bmhq2e4LGYvXzaxWBnUSQrrirSVIrVQS1m3WuMMeta } from "/codebuild/output/src4224255637/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93MalDsBBFVFOyd6SKRNseP__45bwNqED4afKkW_PE6qBuAMeta } from "/codebuild/output/src4224255637/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm9UU3edFGRb_Qo0VwxVr4S1dpqflcZrXp2IXGUGCdvI0Meta } from "/codebuild/output/src4224255637/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93JpC6YYJYdR9lXig07qRDRbFoTvDQsbT_HhL9T1RcIb4Meta } from "/codebuild/output/src4224255637/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexoqaLWuPcalf9NROl6b81BEujYcVrVbfsKvLbzJH5_v0Meta } from "/codebuild/output/src4224255637/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeQFxE7LgzFjJkVzlaBrl1uz2pZvVWV4Yu5eW2cwwoi60Meta } from "/codebuild/output/src4224255637/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codepgwQDIv6F8tG87iSbumtXjyyCeRfBCfMLrDDNjCcbd8Meta } from "/codebuild/output/src4224255637/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeE4le5Xssm_451xtjzp0ibs5euToF0Tdpg_y57HfJmY6TgMeta } from "/codebuild/output/src4224255637/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerD_45vRP1MOtHbZq3nX2IMUiHWlutcJSHXnO2AE2d3fBGMMeta } from "/codebuild/output/src4224255637/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete8FhTfNb626xqMx1VaB_45CYqjLRJlRVmVxKCy9fLNq7wIMeta } from "/codebuild/output/src4224255637/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index7Lw_mkrnk9pGYOi1glegRQQwhSFsEiF054lPXIcpZB4Meta } from "/codebuild/output/src4224255637/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmpkmPxS3F1UZu_F1rwTrZydYSeSJghE8K5KK8hhYp4MoMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completexKoTU_451yQ9RGXKATzqRGn8sLZYghEbldq97kp3cmFlMMeta } from "/codebuild/output/src4224255637/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index6T9_6OWPOvxlR_45Fbbn4CwYm5jdzaFrkefe_O0lgXGjsMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93_NOm_455_X8UotZmh_3yIxEopAr_HJ0WqiurZEWmpgmbcMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeW5tzcsrBsqiO1uJVuIvdIYqVH_GU2OiLgMmS35ACMS0Meta } from "/codebuild/output/src4224255637/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias9mxz_GVQ9SFNVUoXdMnybk06MK4LL1an2_45goV3x0QNYMeta } from "/codebuild/output/src4224255637/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleyh89gCQo0ujoI3OP_45z_QVKRgWx_45K0ISYzjBw7n1KHx0Meta } from "/codebuild/output/src4224255637/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailkTmzKp8P4FkwBA0rvA_45euZmiA8SoI6KvWsNV8XhMmGkMeta } from "/codebuild/output/src4224255637/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmIt6a_45BHtY85th94W20dY_E0R5L4QltcXngo6F5fDGroMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentT5AfFY0jt0p22_45U2_45BDL1ULi1_45QI1Sp5_16K5pJzvC0Meta } from "/codebuild/output/src4224255637/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmjckUhnJGagUni_450WuY7b4qJJbL8sBsxoPo5axxLVs0IMeta } from "/codebuild/output/src4224255637/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedaterkp25hyF_M5uknOXVRfjynecN3H3xJzxHPGgofL0qEAMeta } from "/codebuild/output/src4224255637/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeADy93m5rFbEWq9arZ61KRl9lYe2prhrnNc3y0gChUqsMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codem6oPqQgIvc_45_sTCltCn7mUwwmvG6CDAUDXNZ60bvFT4Meta } from "/codebuild/output/src4224255637/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password9i8IxBEFAX7Dos8GZH91psbytEIY7jhWcvefVdpkqUsMeta } from "/codebuild/output/src4224255637/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliaseQF8i0LeT0kdB8p9bSnN4E6Oqi7Dcp8hPeZTUYclAK8Meta } from "/codebuild/output/src4224255637/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registeri22YQoKPsk4AlAzHaQbn1Z04cl9p5X3fDTx26SKNug8Meta } from "/codebuild/output/src4224255637/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeWbKqhsdCvCz_45mNtmUVGGCtweUm7U_45pmG9KTok0saQuMMeta } from "/codebuild/output/src4224255637/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index7nAq9SyI9Lz02U2OZeylOx2LrG1vYtMweFTqtm6BryoMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexNRk3jgrZIcV8vOADSpx2J7PUdBWexxX_4588INy6E19l8Meta } from "/codebuild/output/src4224255637/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indextZdJi3fO_45QPJOjs2xQ2MxOhuYYur_455pBUtS7AET1fOYMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexNQlS0zrkpjRT0DYCgMSe4hT3mTVaEtASDi_Aj0TrmhsMeta } from "/codebuild/output/src4224255637/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateUz2xxYR8J7CFO3cfzG_t4O8qxwWWNJS8G2t77qrtsXIMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completejtizoVOP_45oCzriiF3QaWofNsHbToFYCRC8MPMuoHl2IMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmQ73D4EAYRvMhJXZ47C_UYBFkL_0JuCjNBW7JjxWUbC8Meta } from "/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index54CJHoH_45E3oJ0mGJrB_45p_45CGjLxEvHNOVBSnRrEAqyu8Meta } from "/codebuild/output/src4224255637/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completexh_45jnO_HtteoJt2kNz93dfz1CXBSHEixHgaJDwd84LwMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateFYeHsXVv_45b_4597pHOqFulFxifcAFQl6MpC7zJPVG3qUwMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexwMCf_M5rUc7Cz5CsmKrhdkpX7Oo_DzHz6Yj2U7By5M8Meta } from "/codebuild/output/src4224255637/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexqneTcbyIWtGdwfnJ1QXA3Cgnirbs_45iQkmtnds54MK7gMeta } from "/codebuild/output/src4224255637/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete1lKyewijtzChp9dGrVU16ujrmKbRX8Afb4b_EThp4uIMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexAlZQQ34nWr79hQEE1OTgKWnCnIbrjKuyNd4_aXdaGEUMeta } from "/codebuild/output/src4224255637/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeNsCRVy_I_45Pdk_45FdCVFWafiEsGl3OmjdSxmFf9hDLKygMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexP4sCtamz19fj_455HWWv8BTWzMWdrHP5PERM3fT_2DFlUMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indextsyYEgW0ppBEVBKTTvWwZpGPiXg1sVxot63grODMlBYMeta } from "/codebuild/output/src4224255637/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index35540_w6yaqMN_nmJbTy0Wed1gG9Sx2bLQ9MjFax7lEMeta } from "/codebuild/output/src4224255637/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateV8xDV9_4_09EwqdqzqATd4_DnOBT_45BFC9nb952mwQLIMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm7tRxvwxD2mV_4515_OgNT_455xKhiS0yfd7nUJNjZVSJsdoMeta } from "/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuPVC7z5_DcptPL7oaVt_45nn5N05OYoiW69_SrY710xGuoMeta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexxbc_ceHR420_45A19iUnoBLDl8CHHwWsnnqxsnPsFT_45TYMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src4224255637/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexsFv3HO9pqguYl1Ngx_45BQLRCPds90RMa4bVpE14oTiesMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src4224255637/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index8PPtmC1j8m7wuu_gRwda32vXpTfLsAFwZ89w8I7vM00Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src4224255637/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexfjiGl1B8ZxKe9Wz4G6lYqukVnlNnMmQjFsn4GCW2K4sMeta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexCKmVaDaI3H349pWWUdg8nZxXdsYAxvU8ANLrCljXTAIMeta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexQA9SoH0csux_IbyOyynkIrIemzyJEYV1pkWVsSfShfEMeta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmoY3iXuPg6f1k5rB3PdwY6avJYLyHAhDdexHccyocHzcMeta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm50KmfiQAJqlqao7mNwEK9OaZhcbpBG1IG26jYY5AXv0Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src4224255637/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completelmE2PECIGLuxPv3ab0LBoQC4BZBu9qLmVloObZiQTQ0Meta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerEnUk1bmhq2e4LGYvXzaxWBnUSQrrirSVIrVQS1m3WuMMeta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm9UU3edFGRb_Qo0VwxVr4S1dpqflcZrXp2IXGUGCdvI0Meta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeQFxE7LgzFjJkVzlaBrl1uz2pZvVWV4Yu5eW2cwwoi60Meta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codepgwQDIv6F8tG87iSbumtXjyyCeRfBCfMLrDDNjCcbd8Meta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeE4le5Xssm_451xtjzp0ibs5euToF0Tdpg_y57HfJmY6TgMeta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerD_45vRP1MOtHbZq3nX2IMUiHWlutcJSHXnO2AE2d3fBGMMeta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmpkmPxS3F1UZu_F1rwTrZydYSeSJghE8K5KK8hhYp4MoMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completexKoTU_451yQ9RGXKATzqRGn8sLZYghEbldq97kp3cmFlMMeta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index6T9_6OWPOvxlR_45Fbbn4CwYm5jdzaFrkefe_O0lgXGjsMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeW5tzcsrBsqiO1uJVuIvdIYqVH_GU2OiLgMmS35ACMS0Meta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleyh89gCQo0ujoI3OP_45z_QVKRgWx_45K0ISYzjBw7n1KHx0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailkTmzKp8P4FkwBA0rvA_45euZmiA8SoI6KvWsNV8XhMmGkMeta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmIt6a_45BHtY85th94W20dY_E0R5L4QltcXngo6F5fDGroMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentT5AfFY0jt0p22_45U2_45BDL1ULi1_45QI1Sp5_16K5pJzvC0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmjckUhnJGagUni_450WuY7b4qJJbL8sBsxoPo5axxLVs0IMeta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeADy93m5rFbEWq9arZ61KRl9lYe2prhrnNc3y0gChUqsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codem6oPqQgIvc_45_sTCltCn7mUwwmvG6CDAUDXNZ60bvFT4Meta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password9i8IxBEFAX7Dos8GZH91psbytEIY7jhWcvefVdpkqUsMeta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registeri22YQoKPsk4AlAzHaQbn1Z04cl9p5X3fDTx26SKNug8Meta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeWbKqhsdCvCz_45mNtmUVGGCtweUm7U_45pmG9KTok0saQuMMeta || {},
    component: () => import("/codebuild/output/src4224255637/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src4224255637/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]